module.exports = __webpack_public_path__ + "img/taken.6f71727c.svg";